<template>
  <div class="question-box-container">
    <b-jumbotron>

      
        <template slot="lead">
          <transition
            name="going-out">
            <div v-if="!goingout">
            {{index}}. {{ currentQuestion.question }}
            </div>
          </transition>
        </template>
      

      <hr class="my-4" />

      <transition
        name="going-out"
        v-on:after-leave="afterGoingOut">

        <b-list-group v-if="!goingout">
          <b-list-group-item
            v-for="(answer, index) in shuffledAnswers"
            :key="index"
            @click.prevent="selectAnswer(index)"
            :class="answerClass(index)"
          >
            {{ answer }}
          </b-list-group-item>
        </b-list-group>

      </transition>

      <b-button
        variant="primary"
        @click="submitAnswer"
        :disabled="selectedIndex === null || answered"
      >
        Submit
      </b-button>
      <b-button 
        @click="gonext" 
        :disabled="!answered"
        variant="success">
          Next
      </b-button>
    </b-jumbotron>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    currentQuestion: Object,
    next: Function,
    increment: Function,
    index: Number
  },
  data: function() {
    return {
      selectedIndex: null,
      correctIndex: null,
      shuffledAnswers: [],
      goingout: false,
      answered: false
    }
  },
  computed: {
    answers() {
      // this function is no longer used in finished code
      // it is replaced by the watch function below and the
      // shuffleAnswers method
      let answers = [...this.currentQuestion.incorrect_answers]
      answers.push(this.currentQuestion.correct_answer)
      return answers
    }
  },
  watch: {
    currentQuestion: {
      immediate: true,
      handler() {
        this.selectedIndex = null
        this.answered = false
        this.shuffleAnswers()
        this.deQuoteAnswers()
        this.currentQuestion.question = this.currentQuestion.question.replace(/&rsquo;/g,'\'').replace(/&quot;/g,'"').replace(/&#039;/g,'\'')
      }
    }
  },
  methods: {
    selectAnswer(index) {
      if (!this.answered) {
        this.selectedIndex = index
      }
    },
    gonext() {
      if (this.index < 10) {
        this.goingout = true
      } else {
        this.next() // finish last question without slide animation
      }
    },
    afterGoingOut() {
      this.next()
      this.goingout = false
    },
    submitAnswer() {
      let isCorrect = false

      if (this.selectedIndex === this.correctIndex) {
        isCorrect = true
      }
      this.answered = true

      this.increment(isCorrect)
    },
    shuffleAnswers() {
      let answers = [...this.currentQuestion.incorrect_answers, this.currentQuestion.correct_answer]
      this.shuffledAnswers = _.shuffle(answers)
      this.correctIndex = this.shuffledAnswers.indexOf(this.currentQuestion.correct_answer)
    },
    deQuoteAnswers() {
      for(let i=0; i < this.shuffledAnswers.length; i++) {
        this.shuffledAnswers[i] = this.shuffledAnswers[i].replace(/&rsquo;/g,'\'').replace(/&quot;/g,'"').replace(/&#039;/g,'\'')
      }
    },
    answerClass(index) {
      let answerClass = ''

      if (!this.answered && this.selectedIndex === index) {
        answerClass = 'selected'
      } else if (this.answered && this.correctIndex === index) {
        answerClass = 'correct'
      } else if (this.answered &&
        this.selectedIndex === index &&
        this.correctIndex !== index
      ) {
        answerClass = 'incorrect'
      }

      return answerClass
    }
  }
}
</script>

<style scoped>

/* transition of question */
.going-out-enter-active {
  transition: all .4s;
}

.going-out-leave-active {
  transition: all .4s;
}

.going-out-enter {
  opacity: 0;
  transform: translateX(250px) scaleX(0);
}

.going-out-leave-to {
  opacity: 0;
  transform: translateX(-250px) scaleX(0);
}


.list-group {
  margin-bottom: 15px;
}

.list-group-item {
  border: 0px;
}

.list-group-item:hover {
  background: #EEE;
  cursor: pointer;
}

.btn {
  margin: 0 5px;
}

.selected {
  background-color: lightblue !important;
}

.correct {
  background-color: MediumSeaGreen !important;
}

.incorrect {
  background-color: tomato !important;
}
</style>
